export default __webpack_public_path__ + "static/media/ss_window.f18e44bc.jpg";